import request from "../utils/request";

export function kdserviceSessionid(params){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.AuthService.ValidateUser.common.kdsvc',
        // params:params
        data:params
    })
}

export function loginByAppSecret(params){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.AuthService.LoginByAppSecret.common.kdsvc',
        // params:params
        data:params
    })
}


//切换组织
export function switchOrg(params){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.SwitchOrg.common.kdsvc',
        // params:params
        data:params
    })
}


export function executeBillQuery(data){
    // console.log('登录')
    // console.log(data)
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.ExecuteBillQuery.common.kdsvc',
        data:data
    })
}

export function billView(data){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.View.common.kdsvc',
        data:data
    })
}


export function getSupplyToken(params={}){
    return request({
        method:'POST',
        url:'/',
        params,
    })
}

// 注册用户
export function enrollCustomer(data){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.Save.common.kdsvc',
        data:data,
    })
}

export function submit(data){
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.Submit.common.kdsvc',
        data:data
    })
}